var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.444 2 20 5.636m0 0-3.556 3.637M20 5.636H7.556c-.943 0-1.848.383-2.515 1.065A3.68 3.68 0 0 0 4 9.273v1.818M7.556 22 4 18.364m0 0 3.556-3.637M4 18.364h12.444c.943 0 1.848-.384 2.515-1.065A3.68 3.68 0 0 0 20 14.727V12.91"
  })));
};
export default SvgRepeat;